import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";

import { FuseSharedModule } from "@fuse/shared.module";

import { ScheduleSummaryComponent } from "./schedule-summary.component";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatOptionModule } from "@angular/material/core";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatButtonModule } from "@angular/material/button";
import { MatDatepicker, MatDatepickerModule } from "@angular/material/datepicker";
import { MatIconModule } from "@angular/material/icon";
import { MatTableModule } from "@angular/material/table";
import { ScheduleSummaryService } from "./schedule-summary.service";
import { SnackBarService } from "app/services/snackbar.service";
import { CheckinService } from "../checkin/checkin.service";
import { FuseConfirmDialogComponent } from "@fuse/components/confirm-dialog/confirm-dialog.component";
import { NgxMaskModule } from "ngx-mask";

const routes = [
    {
        path: "resumo-agenda",
        component: ScheduleSummaryComponent,
    },
];

@NgModule({
    declarations: [ScheduleSummaryComponent],
    imports: [
        RouterModule.forChild(routes),

        TranslateModule,
        NgxMaskModule,
        FuseSharedModule,
        MatFormFieldModule,
        MatInputModule,
        MatOptionModule,
        MatSelectModule,
        MatTableModule,
        MatButtonModule,
        MatIconModule,
        MatDatepickerModule,
        MatAutocompleteModule,
        
    ],
    providers: [ScheduleSummaryService, SnackBarService, CheckinService],
    exports: [ScheduleSummaryComponent],
    entryComponents: [FuseConfirmDialogComponent]
})
export class ScheduleSummaryModule {}
